import React, { useState, useEffect } from 'react';
import {
  Container,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  TextField,
  Typography,
  withStyles
} from '@material-ui/core';
import MuiAlert, { type Color } from '@material-ui/lab/Alert';
import { Link } from 'react-router-dom';
import { type IStatus } from '.';
import { api } from '../../../services/api';
import { Autocomplete } from '@material-ui/lab';
import { status } from '@data/status';
import { ASO } from '@data/tipoAso';
import { ColaboradorProps, SearchCPF } from '@components/SearchCPF';
import { useAuth } from '@context/auth';
import { useMutation, useQuery } from '@tanstack/react-query';
import { NavLink } from '@components/NavLink';
import { Button } from '@components/Button';
import { InputSearchColab } from '@components/InputSearchColab';
import { AppError } from '@utils/AppError';

interface IColaborador {
  id_colaboradores: number;
  matricula_empresa: string;
  matricula_esocial: any;
  nome_completo: string;
  cpf_colaborador: string;
  rg: string;
  data_nascimento: string;
  genero: string;
  cnh: string;
  email: string;
  telefone: string;
  situacao: string;
  nis: string;
  funcao: string;
  setor: string;
  turno: string;
  cnpj: string;
  razao_social: string;
  data_admissao: string;
  horario_trab_entrada: string;
  horario_trab_saida: string;
  local_obra: string;
  cod_ghe: any;
  ghe: string;
}
interface INomeComercial {
  id_clinicas_credenciadas: number;
  contrato: string;
  nome_comercial: string;
  razao_social: string;
  cpf_cnpj: string;
  dias_funcionamento: string;
  cep: string;
  rua: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  nome_med: string;
  crm: string;
  crm_estado: string;
  trabalho_agendamento: string;
  pagamento_adiantado: string;
  telemedicina: string;
  observacao: string;
}

export const AgendamentoToxicologico: React.FC<IStatus> = (props) => {
  const { user } = useAuth();
  const [listNomeComercial, setListNomeComercial] = useState<INomeComercial[]>(
    []
  );
  const [selectedNomeComercial, setSelectedNomeComercial] = useState<any>();
  const [searchEmail, setSearchEmail] = useState<any>();
  const [emailAgendamento, setEmailAgendamento] = useState([]);

  const [messageError, setMessageError] = useState('');
  const [loadingColab, setLoadingColab] = useState(false);

  const [statusAgendamento, setStatusAgendameto] = useState('');
  const [cpfColab, setCpfColab] = useState('');
  const [nomeColab, setNomeColab] = useState('');
  const [estado, setEstado] = useState('');
  const [cidade, setCidade] = useState('');
  const [dataAgendamento, setDataAgendamento] = useState('');
  const [horarioAgendamento, setHorarioAgendamento] = useState('');
  const [tipoAso, setTipoAso] = useState('');
  const [obs, setObs] = useState('');
  const [cnpjComercial, setCnpjComercial] = useState('');
  const [comboColab, setComboColab] = useState<IColaborador[]>([]);
  const [isLoandingField, setIsLoandingField] = useState(false);

  const [snack, setSnack] = useState<boolean>(false);
  const [message, setMessage] = useState('');
  const [cod, setCod] = useState('');
  const [severity, setSeverity] = useState<Color>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function sendAgendamento() {
    const hora = new Date();
    setIsSubmitting(true);

    const newHora = hora.toLocaleString('pt-BR', { hour12: false });
    const data = {
      status: statusAgendamento,
      observacao: obs,
      tipo_aso: tipoAso,
      horario: horarioAgendamento,
      data_agendamento: dataAgendamento,
      estado,
      cidade,
      nome_comercial: selectedNomeComercial,
      tipo_agendamento: props.location.state.tipo_agendamento,
      nome: nomeColab,
      cpf_colaborador: cpfColab,
      num_agenda: null,
      usuario: `${user.nome} ${newHora}`,
      email_agendamento: emailAgendamento,
      ordem_chegada: null,
      cpf_cnpj_comer: cnpjComercial
    };
    // console.log(data)

    try {
      const res = await api.post(`/ravim/agendamento-toxicologico`, data);
      setCod(String(res.status));
      setSnack(true);
      setSeverity('success');
      setMessage(res.data.message);
      setTimeout(() => {
        window.location.replace('/agendamentos');
      }, 1000);
    } catch (error) {
      if (error instanceof AppError) {
        setCod(String(error.code));
        setSnack(true);
        setSeverity('error');
        setMessage(String(error.message));
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  const { data: returnNomeComercial, mutate } = useMutation({
    mutationKey: ['postNomeCredenciado'],
    mutationFn: async (obj: object) => {
      return await api.post(`/ravim/telemed-clinicas`, obj);
    }
  });

  useEffect(() => {
    mutate({
      tipo_agendamento: props.location.state.tipo_agendamento,
      tipo: props.location.state.tipo_agendamento
    });
  }, [props.location.state.tipo_agendamento]);

  async function handleSearchCpf(cpf: string) {
    setCpfColab(cpf);

    try {
      setLoadingColab(true);
      if (cpf.length === 14) {
        const response = await api.post(`ravim/pesq-cpf`, {
          cpf_colaborador: cpf
        });
        setNomeColab(response.data.nome_completo);
      }
    } catch (error) {
      if (error instanceof AppError) {
        if (error.code === 400) {
          setNomeColab('');
          setMessageError(error.message);
        }
      }
    } finally {
      setLoadingColab(false);
    }
  }

  useEffect(() => {
    if (cpfColab.length <= 0) {
      setMessageError('');
      setNomeColab('');
    }
    if (nomeColab) {
      setMessageError('');
    }
  }, [cpfColab, nomeColab]);

  return (
    <Container>
      <Typography
        variant="h4"
        align="center"
        style={{ marginBottom: 20, fontWeight: 'bold' }}
      >
        Agendamento Toxicológico
      </Typography>
      <Paper style={{ padding: 40 }}>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Status
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <FormControl variant="outlined" style={{ width: '20%' }}>
                <InputLabel>Status</InputLabel>
                <Select
                  label="Status"
                  value={statusAgendamento}
                  onChange={(e: any) => {
                    setStatusAgendameto(e.target.value);
                  }}
                >
                  {status.map((status, index) => (
                    <MenuItem key={index} value={status.value}>
                      {status.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Colaborador
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <InputSearchColab
                label="CPF"
                value={cpfColab}
                onChange={(e) => handleSearchCpf(e.toString())}
                errorShow={!!messageError}
                textError={messageError}
                isLoading={loadingColab}
              />
              <TextField
                disabled
                label="Nome"
                variant="outlined"
                fullWidth
                value={nomeColab}
                onChange={(e) => {
                  setNomeColab(e.target.value);
                }}
              />
            </div>
            <Typography variant="h5" style={{ fontWeight: 'bold', margin: 10 }}>
              Atendimento por Toxicológico
            </Typography>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <Autocomplete
                defaultValue={null}
                fullWidth
                id="tags-outlined"
                options={returnNomeComercial?.data}
                getOptionSelected={(option, value) =>
                  option.cpf_cnpj === value.cpf_cnpj
                }
                getOptionLabel={(option: INomeComercial) =>
                  `${option?.cpf_cnpj}`
                    ? `${option?.nome_comercial} - ${option?.estado} - ${option?.cidade}`
                    : ''
                }
                onChange={(e, newValue: any) => {
                  setSearchEmail(newValue.cpf_cnpj);
                  setSelectedNomeComercial(newValue.nome_comercial);
                  setCnpjComercial(newValue.cpf_cnpj);
                  setCidade(newValue.estado);
                  setEstado(newValue.cidade);
                }}
                value={selectedNomeComercial}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Nome Credenciado"
                    placeholder={
                      returnNomeComercial?.data.length === 0
                        ? 'Não há credenciadiado cadastrado'
                        : 'Nome Credenciado'
                    }
                  />
                )}
              />
            </div>

            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <TextField
                label="Data do agendamento"
                variant="outlined"
                type="date"
                InputLabelProps={{
                  shrink: true
                }}
                fullWidth
                value={dataAgendamento}
                onChange={(e) => {
                  setDataAgendamento(e.target.value);
                }}
              />
              <TextField
                label="Horário"
                type="time"
                variant="outlined"
                fullWidth
                InputLabelProps={{
                  shrink: true
                }}
                value={horarioAgendamento}
                onChange={(e) => {
                  setHorarioAgendamento(e.target.value);
                }}
              />
            </div>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <FormControl variant="outlined" style={{ width: '20%' }}>
                <InputLabel>Tipo de ASO</InputLabel>
                <Select
                  label="Tipo de ASO"
                  value={tipoAso}
                  onChange={(e: any) => {
                    setTipoAso(e.target.value);
                  }}
                >
                  {ASO.map((aso, index) => (
                    <MenuItem key={index} value={aso.value}>
                      {aso.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            <div style={{ display: 'flex', gap: 20, margin: 15 }}>
              <TextField
                minRows={4}
                label="OBS"
                multiline
                variant="outlined"
                value={obs}
                onChange={(e) => {
                  setObs(e.target.value);
                }}
                fullWidth
              />
            </div>
          </Grid>
        </Grid>
      </Paper>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 20,
          marginTop: 20
        }}
      >
        <NavLink to={{ pathname: '/agendar', state: { exit: true } }}>
          <Button title="Sair" variantstyle="RED" />
        </NavLink>
        <Button
          title="Cadastrar"
          disabled={isSubmitting}
          onClick={sendAgendamento}
        />
      </div>
      <Snackbar
        open={snack}
        autoHideDuration={2000}
        onClose={() => {
          setSnack(!snack);
        }}
      >
        <MuiAlert
          severity={severity}
          variant="filled"
        >{`${cod} - ${message}`}</MuiAlert>
      </Snackbar>
    </Container>
  );
};
